type AutoId = string | undefined;

type AutoIdProps = Partial<{
    ['data-testid']: string;
}>;

export function autoId(id: AutoId): AutoIdProps {
    return id
        ? {
              'data-testid': id
          }
        : {};
}
